<template lang="pug">
BriqTable.data-test-message-log-table
  thead
    th Insert Date
    th Direction
    th Action
    th Method
    th URL
    th Status
    th 
  tbody
    template(v-for="item in logData")
      tr.audit-trail-data-col(@click="item.showDetals = !item.showDetals")
        td {{ prettyDate(item.RequestDatetimeUtc) }}
        td {{ item.RequestDirection }}
        td {{ item.ActionName }}
        td {{ item.RequestMethod }}
        td {{ item.RequestUri }}
        td {{ item.ResponseStatus }}
        td
          .show-detals-btn(:class="item.showDetals ? `rotate-180` : ``")
            BriqIcon(name="icon-input-arrow-down-icon")
      tr(v-if="item.showDetals")
        td(colspan="6") 
          .logs-details-table
            BriqTable
              tbody
                tr
                  td.title Content-type	
                  td {{ item.RequestContentType }}
                  td.title Linked object	
                  td {{ item.ObjectType }}
                tr
                  td.title Machine
                  td {{ item.Machine }}
                  td.title Instance
                  td {{ item.Instance }}
                tr
                  td.title URI
                  td(colspan="3") {{ item.RequestUri }}
                tr
                  td.title(colspan="2") Request Message
                  td.title(colspan="2") Response Message
                tr
                  td(colspan="2") 
                    div {{ prettyDate(item.RequestDatetimeUtc) }}
                  td(colspan="2") 
                    div {{ prettyDate(item.ResponseDatetimeUtc) }}
                tr
                  td(colspan="2") {{ item.RequestHeaders }}
                  td(colspan="2") {{ item.ResponseHeaders }}
                tr
                  td(colspan="2")  
                    textarea(readonly) {{ item.RequestMessage }}
                  td(colspan="2")  
                    textarea(readonly) {{ item.ResponseMessage }}
</template>

<script>
import logTablesMixin from './logTablesMixin.js'

export default {
  name: 'MessageLogTable',
  mixins: [logTablesMixin],
  props: {
    logData: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/components-global/BriqViewAuditTrail/tableStyle.styl'
</style>
